import './MonitorDetails.scss';

import classNames from 'classnames';
import { ConfigurableFieldAccess } from './ConfigurableFieldAccess';
import { MONITOR_VALIDATION_RULES } from '@security/@arch/validation';
import { NewObjectAndFieldAccess } from './NewObjectAndFieldAccess';
import React from 'react';
import { SetupAuditTrail } from './SetupAuditTrail';
import { SonarText } from '@ui/text';
import { Uptime } from '.';
import { When } from 'react-if';

import { COPY_SPECIFIC, PLACEHOLDERS_COPY } from '@sonar-software/sonar-ts-constants';
import {
	DataSecurityMonitor,
	DataSecurityMonitorType,
	SetupAuditTrailMonitor,
	UptimeMonitor
} from '@sonar-software/sonar-core';
import { Form, Input, Space } from 'antd';

export interface MonitorDetailsProps {
	editing?: boolean
	fieldId?: number
	hideName?: boolean
	noMargin?: boolean
	monitor: DataSecurityMonitor
}

export const MonitorDetails: React.FC<MonitorDetailsProps> = ({
	editing = false,
	fieldId,
	hideName = false,
	noMargin = false,
	monitor
}) => {
	let details = undefined;

	switch (monitor.monitorConfig.monitorTypeId) {
		case DataSecurityMonitorType.Uptime:
			details = <Uptime
				editing={ editing }
				fieldId={ fieldId }
				monitor={ monitor as UptimeMonitor } />;
			break;
		case DataSecurityMonitorType.SetupAuditTrail:
			details = <SetupAuditTrail
				monitor={ monitor as SetupAuditTrailMonitor } />;
			break;
		case DataSecurityMonitorType.ConfigurableFieldAccess:
			details = <ConfigurableFieldAccess />;
			break;
		case DataSecurityMonitorType.NewObjectAndFieldAccess:
			details = <NewObjectAndFieldAccess />;
			break;
		default:
	}

	return (
		<Space
			align='start'
			className={ classNames('monitor-details', { margin: !noMargin }) }
			direction='vertical'>
			<SonarText className='h2'>
				{ COPY_SPECIFIC.MONITOR_DETAILS }
			</SonarText>
			<When condition={ !hideName }>
				<Form.Item
					className='monitor-details-name'
					id='monitor-details-name'
					initialValue={ monitor.name }
					label={ COPY_SPECIFIC.NAME }
					name={ fieldId === undefined ? 'name' : [ fieldId, 'name' ] }
					rules={ [ ...MONITOR_VALIDATION_RULES.NAME ] }>
					<Input
						disabled={ !editing }
						placeholder={ PLACEHOLDERS_COPY.NAME_YOUR_MONITOR } />
				</Form.Item>
			</When>
			{ details }
		</Space>
	);
};
